<template>
  <div id="app">
    <Header />
    <router-view />
  </div>
</template>

<script>
import Header from './components/Header.vue';

export default {
  components: { Header },
  created() {
    this.$store.dispatch('getPages');
    this.$store.dispatch('getColumns');
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;700&family=Suranna&display=swap");

:root {
  --white: #ffffff;
  --very-light: #f0f0f0;
  --black: #000000;
  --very-dark: #333333;
  --mid-grey: #494949;
  --fawn: #d5a572;
  --dark-purple: #260c1a;
  --old-burgandy: #432e36;
  --liver: #260c1a;
  --blue: #76949f;
  --twenty-five-lighter: rgba(255, 255, 255, 0.25);
  --ten-darker: rgba(0, 0, 0, 0.1);
  --headline-font: "Suranna", serif;
  --body-font: "Nunito", sans-serif;
}

html,
body {
  margin: 0;
  padding: 0;
}

* {
  box-sizing: border-box;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: var(--body-font);
  color: var(--black);
}

.container {
  margin: 0 auto;
  max-width: 1240px;
  padding: 0 24px;
}
</style>
